import { UsePlayerBingoGameStatusResult } from "bingo/play/views/types/bingo.game.view.types";
import { useGetPlayerQuery } from "quiz/api/players.endpoints";

export function usePlayerBingoGameStatus(
  playerId: string,
  partitionId: string,
): UsePlayerBingoGameStatusResult {
  const {
    data: player,
    isLoading,
    error,
    refetch, // Add refetch
  } = useGetPlayerQuery([playerId, partitionId]);

  const hasGrid = player?.bingoGridNumbers
    ? Array.isArray(player.bingoGridNumbers) &&
      player.bingoGridNumbers.length > 0
    : false;

  const savedEntries = player?.bingoEntries || [];

  return { hasGrid, savedEntries, player, isLoading, error, refetch }; // Return refetch
}
